module.exports = __webpack_public_path__ + "static/img/log_03.a1b8b1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/log_03.png
// module id = wz/g
// module chunks = 0